import { Button, Card } from "@material-ui/core";
import Container from "@saleor/components/Container";
import { IFilter } from "@saleor/components/Filter";
import FilterBar from "@saleor/components/FilterBar";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import { CouponCollectionListQuery_couponCollections_edges_node } from "@saleor/coupons/types/CouponCollectionListQuery";
import {
  couponCollectionAddUrl,
  couponRankingListUrl
} from "@saleor/coupons/url";
import { SubmitPromise } from "@saleor/hooks/useForm";
import useListSettings from "@saleor/hooks/useListSettings";
import useNavigator from "@saleor/hooks/useNavigator";
import {
  ListViews,
  PageListProps,
  SearchPageProps,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import CouponCollectionTable from "../CouponCollectionTable";

export interface CouponCollectionListProps
  extends TabPageProps,
    PageListProps,
    SearchPageProps {
  data: CouponCollectionListQuery_couponCollections_edges_node[];
  onSubmit: (data) => SubmitPromise;
}

export const CouponCollectionList: React.FC<CouponCollectionListProps> = ({
  data,
  onTabChange,
  onTabDelete,
  onTabSave,
  onNextPage,
  onPreviousPage,
  onUpdateListSettings,
  onSearchChange,
  onSubmit,
  initialSearch,
  tabs,
  ...listProps
}) => {
  const intl = useIntl();
  const breadcrumbDirectory = [
    {
      name: "Coupon Collection"
    }
  ];
  const navigate = useNavigator();
  const { settings } = useListSettings(ListViews.COUPON_COLLECTION_LIST);

  const handleViewCouponRankingClick = () => {
    const currentSearchParams = location.search;
    const cleanSearchParams = currentSearchParams.startsWith("?")
      ? currentSearchParams.slice(1)
      : currentSearchParams;
    const rankingListUrl = couponRankingListUrl().endsWith("?")
      ? couponRankingListUrl().slice(0, -1)
      : couponRankingListUrl();
    navigate(`${rankingListUrl}?${cleanSearchParams}`);
  };

  const allowFeatureCouponList = true;
  const hasCouponCollectionRanking = false;

  return (
    <Container>
      <PageBreadcrumbNavigation items={breadcrumbDirectory} />
      <PageHeader title={"Coupon Collection"}>
        {hasCouponCollectionRanking && (
          <Button
            variant="outlined"
            color="primary"
            style={{ marginRight: "8px" }}
            onClick={handleViewCouponRankingClick}
            id="viewRankingBtn"
          >
            <span style={{ color: "#1848FE", fontWeight: "bold" }}>
              <FormattedMessage
                defaultMessage="View Coupon Ranking"
                description="button"
              />
            </span>
          </Button>
        )}

        <Button
          color="primary"
          variant="contained"
          onClick={() => navigate(couponCollectionAddUrl())}
          id="createCollectionBtn"
          style={{ backgroundColor: "#1848FE" }}
        >
          <span style={{ color: "#ffffff", fontWeight: "bold" }}>
            <FormattedMessage
              defaultMessage="Create Collection"
              description="button"
            />
          </span>
        </Button>
      </PageHeader>
      <Card>
        <FilterBar
          tabs={tabs}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Coupon Collection Title"
          })}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
          disablePlusOneTab={true}
          hideAction={true}
          currencySymbol={""}
          filterStructure={[]}
          initialSearch={initialSearch}
          currentTab={0}
          onFilterChange={function(filter: IFilter<string>): void {
            throw new Error(`"Function not implemented." ${filter}`);
          }}
          onSearchChange={onSearchChange}
        />
        <CouponCollectionTable
          collections={data}
          userHasFeatureCouponAccess={allowFeatureCouponList}
          disabled={false}
          settings={settings}
          onNextPage={onNextPage}
          onPreviousPage={onPreviousPage}
          onUpdateListSettings={onUpdateListSettings}
          onSubmit={onSubmit}
          {...listProps}
        />
      </Card>
    </Container>
  );
};
export default CouponCollectionList;
